/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-07-07 12:16:55
 * @Description:
 */
import { createStore } from 'vuex'
import baseconfig from '@/utils/beasconfig'
let msg = {
  'zhTW': 'cn2',
  'zh': 'cn',
  'en': 'en',
  'epn': 'epn',
  'fn': 'fn',
  'tn': 'tn',
  'ind': 'ind'
}

export default createStore({
  state: {
    appId: baseconfig.appId,
    appSecret: baseconfig.appSecret,
    loginInfo: sessionStorage.getItem("loginInfo") ? JSON.parse(sessionStorage.getItem("loginInfo")) : '',
    ptInfo: localStorage.getItem("ptInfo") ? JSON.parse(localStorage.getItem("ptInfo")) : '',
    agentinfo: sessionStorage.getItem("agentInfo") ? JSON.parse(sessionStorage.getItem("agentInfo")) : '',
    pathmini: sessionStorage.getItem("pathmini") ? sessionStorage.getItem("pathmini") : '',
    orginfo: sessionStorage.getItem("orgInfo") ? JSON.parse(sessionStorage.getItem("orgInfo")) : '',
    okColor: '#576b95',   //确认颜色
    languageType: window.XINPOC_WEB_CONFIG.languageArr,
    language: localStorage.getItem('language') || window.XINPOC_WEB_CONFIG.defaultLanguage, //中英文
    langMsg: localStorage.getItem('language') ? msg[localStorage.getItem('language')] : window.XINPOC_WEB_CONFIG.defaultLanguage,  //提示的字段
    t: window.$t,     //中英文
    roleId: localStorage.getItem('roleId') ? Number(localStorage.getItem('roleId')) : 0,   //0代理商 1单位
    agent_name: '全球对讲',
    orgFenceUrl: sessionStorage.getItem("orgFenceUrl") ? sessionStorage.getItem("orgFenceUrl") : '',
    fenceUrlDk: sessionStorage.getItem("orgFenceUrl") ? `http://${sessionStorage.getItem("orgFenceUrl")}/electronicFence/list` : '',
    isXin: false,
    isCardSwitch: sessionStorage.getItem('isCardSwitchMini') ? JSON.parse(sessionStorage.getItem('isCardSwitchMini')) : null,      //显示卡开关
    platform: 'xin_poc',
    XINPOC_WEB_CONFIG:window.XINPOC_WEB_CONFIG,
    isVoiceGpscard:window.XINPOC_WEB_CONFIG.isProject == "yuantong"
  },
  getters: {
  },
  mutations: {
    getlanguageMsg (state) {
      state.langMsg = state.language ? msg[state.language] : window.XINPOC_WEB_CONFIG.defaultLanguage;
    }
  },
  actions: {
  },
  modules: {
  }
})
